module.exports = __webpack_public_path__ + "static/media/Helo_Carneiro_Asanas.7100c273.jpg";